import React, { useEffect, useMemo, useRef, useState } from "react";
import { useGLTF, Html } from "@react-three/drei";
import { useThree , extend} from "@react-three/fiber";
import gsap from "gsap";
import {useManosStore} from './hooks'
import { EffectComposer, Vignette, DotScreen} from '@react-three/postprocessing'
import * as THREE from 'three'
import { UnrealBloomPass } from 'three-stdlib';

extend({ UnrealBloomPass });
const ArcadeWorld = (props) => {
  const { nodes, materials } = useGLTF("assets/arcade.gltf");
  const { scene, camera, size } = useThree()
  const screenRef = useRef()
  const iFrameRef = useRef()
  
  const aspect = useMemo(
    () => new THREE.Vector2(size.width, size.height),
    [size]
  );

  const {zoomArcade,closeArcade,setCloseArcade,setZoomArcade,instructionsClosed,showIframe,setShowIframe} = useManosStore()

   useMemo(() => {
      if (showIframe && zoomArcade && closeArcade)
      {
        setShowIframe(false)
        
        setZoomArcade(false)
        
        gsap.timeline({onComplete:()=>{
          setCloseArcade(false)
        }})
        .to(
          camera.position, { x: -2.5, y: Math.PI * 2, z: 17, duration: 2 }, 0)
        .to(
          camera.rotation, { x: -0.25, y: - Math.PI /34, z: -0.05, duration: 2 }, 0)
        }
    
  },[zoomArcade,closeArcade,showIframe])

  useMemo(()=>{
    if (instructionsClosed)
    {
      console.log('called')
      iFrameRef?.current?.focus()
    }
  },[instructionsClosed,iFrameRef?.current])


  return (
    <group {...props} dispose={null}>
      <group
        position={[0.11, 2.06, 0.61]}
        rotation={[0, 1.21, 0]}
        scale={[1.42, 1.42, 1.64]}
      >
        <mesh
          castShadow
          geometry={nodes.Cube002.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          castShadow
          geometry={nodes.Cube002_1.geometry}
          material={materials["Material.002"]}
        />
        <mesh
          castShadow
          geometry={nodes.Cube002_2.geometry}
          material={materials.Screen}

          ref={screenRef}
        >
          <EffectComposer
          multisampling={8}
      renderIndex={1}
      disableGamma
      // enabled={showIframe}
      disableRenderPass
      >
        <DotScreen scale={2} angle={40} opacity={0.005} />
        {showIframe && <Vignette eskil={false} offset={0.3} darkness={1.4}/> }
      </EffectComposer>
          {showIframe && (
            <Html
              wrapperClass="crt arcadeScreen"
              transform
              distanceFactor={2}
              scale={0.5}
              rotation-y={-13.7}
              position={[1.33, 1.32, -0.35]}
            >
              <iframe src="https://manolismakris.com" ref={iFrameRef}/>
            </Html>)
          }
        </mesh>
        <mesh
          castShadow
          geometry={nodes.Cube002_3.geometry}
          material={materials["Joystick Ball"]}
        />
        <mesh
          castShadow
          geometry={nodes.Cube002_4.geometry}
          material={materials.Black}
        />
      </group>
    </group>
  );
}


export default ArcadeWorld
useGLTF.preload("/assets/arcade.gltf");